export default "__VITE_ASSET__DNOs9MQD__"